import clsx from "clsx";
import type { ReactNode } from "react";
import style from "./Tabs.module.css";
import { useTabsContext } from "./useTabsContext";

interface TabsTriggerProps {
  value: string;
  children: ReactNode;
}

export function TabsTrigger({ value, children }: TabsTriggerProps) {
  const { activeValue, setActiveValue, idPrefix } = useTabsContext();

  return (
    <button
      role="tab"
      id={`${idPrefix}-trigger-${value}`}
      aria-selected={activeValue === value}
      aria-controls={`${idPrefix}-panel-${value}`}
      className={clsx(
        "ps-tw-reset",
        style["tabs__nav-link"],
        activeValue === value && style["tabs__nav-link--active"]
      )}
      onClick={() => setActiveValue(value)}
    >
      {children}
    </button>
  );
}
